import React from "react";

/**
 * Mensorio — MT serif monogram.
 * Editorial luxury construction built with pure SVG paths.
 * Dominant gold accent, offset M+T letterforms with thin rule.
 */
export const MTLogo = ({ size = 40, className = "", gold = "#C5A059", onDark = true }) => {
  const ink = onDark ? "#F7F3EA" : "#050505";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid="mt-monogram"
      aria-label="Mensorio monogram"
    >
      {/* outer thin rule */}
      <rect x="1" y="1" width="62" height="62" fill="none" stroke={gold} strokeWidth="0.75" />
      {/* Inner rule tick marks */}
      <line x1="10" y1="6" x2="54" y2="6" stroke={gold} strokeWidth="0.5" />
      <line x1="10" y1="58" x2="54" y2="58" stroke={gold} strokeWidth="0.5" />
      {/* M form (serif, thin strokes) */}
      <path
        d="M13 44 L13 20 L20 20 L26 32 L32 20 L39 20 L39 44"
        fill="none"
        stroke={ink}
        strokeWidth="1.2"
        strokeLinejoin="miter"
        strokeLinecap="square"
      />
      {/* Serifs on M */}
      <line x1="10" y1="20" x2="16" y2="20" stroke={ink} strokeWidth="1" />
      <line x1="36" y1="20" x2="42" y2="20" stroke={ink} strokeWidth="1" />
      <line x1="10" y1="44" x2="16" y2="44" stroke={ink} strokeWidth="1" />
      <line x1="36" y1="44" x2="42" y2="44" stroke={ink} strokeWidth="1" />
      {/* T form overlapping right shoulder in gold */}
      <line x1="34" y1="22" x2="54" y2="22" stroke={gold} strokeWidth="1.2" />
      <line x1="44" y1="22" x2="44" y2="48" stroke={gold} strokeWidth="1.2" />
      {/* T serifs */}
      <line x1="34" y1="20.5" x2="34" y2="23.5" stroke={gold} strokeWidth="0.9" />
      <line x1="54" y1="20.5" x2="54" y2="23.5" stroke={gold} strokeWidth="0.9" />
      <line x1="41" y1="48" x2="47" y2="48" stroke={gold} strokeWidth="0.9" />
    </svg>
  );
};

export default MTLogo;
